import { api } from './core';

export type ContractCreditSource =
  | 'coupon'
  | 'coupon_applied'
  | 'lesson_cancellation'
  | 'manual_adjustment'
  | 'refund'
  | string;

export interface CreditSource {
  type: ContractCreditSource;
  amountCents: number;
  label: string;
  description: string | null;
}

export interface CreditBalance {
  balanceCents: number;
  currency: string;
  sources: CreditSource[];
}

export interface CreditHistoryEntry {
  id: number;
  amountCents: number;
  currency: string;
  sourceType: ContractCreditSource;
  sourceRef: string | null;
  description: string | null;
  createdAt: string;
  createdByUserId: number | null;
}

export interface CustomerCreditEntry {
  enrollmentId: number;
  status: string;
  instrumentName: string | null;
  teacherName: string | null;
  standortName: string | null;
  startDate: string | null;
  subprofileId: string;
  balance: CreditBalance;
  history: CreditHistoryEntry[];
}

export interface GrantCreditRequest {
  amountCents: number;
  description: string;
  sourceType?: 'manual_adjustment' | 'lesson_cancellation' | 'refund';
  idempotencyKey: string;
}

export interface GrantCreditResponse {
  ok: boolean;
  ledgerId: number;
  balance: CreditBalance;
}

export const creditsApi = {
  listForCustomer: async (wpUserId: number): Promise<{ items: CustomerCreditEntry[] }> => {
    return api.get<{ items: CustomerCreditEntry[] }>(`/api/customers/${wpUserId}/credits`);
  },

  grant: async (enrollmentId: number, body: GrantCreditRequest): Promise<GrantCreditResponse> => {
    return api.post<GrantCreditResponse>(`/api/subscriptions/${enrollmentId}/credits`, body);
  },
};

export const CREDIT_SOURCE_LABEL: Record<string, string> = {
  coupon: 'Geschenk-Coupon',
  coupon_applied: 'Coupon-Anrechnung',
  lesson_cancellation: 'Ausgefallene Unterrichtseinheit',
  manual_adjustment: 'Anpassung durchs Büro',
  refund: 'Rückerstattung',
  credit_applied: 'Guthaben-Anrechnung',
  credit_applied_reversed: 'Anrechnung storniert',
};
